import { OrderStatus } from "enums";
import { RadiologyCountersProps, RadSection } from "./types";
import { Flex, Icon } from "@chakra-ui/react";
import React from "react";
import { useFormContext } from "react-hook-form";
import { OrderHeaderCard } from "modules/orders";
import { SquaredChecked } from "icons";
import { EmrInProcess, EmrRegistration } from "@medstonetech/slate-icons";

function RadiologyCounters({ filter, setFilter }: RadiologyCountersProps) {
  const { watch } = useFormContext();

  const items = watch("rad");
  const handleSetFilter = (newFilter: OrderStatus) => {
    if (filter === newFilter) {
      setFilter(null);
    } else {
      setFilter(newFilter);
    }
  };

  const getCounter = React.useCallback(
    (status: string) => {
      let counter = 0;
      if (items) {
        counter = items?.filter(
          (item: RadSection) => item?.status === status
        ).length;
      }
      return counter;
    },
    [items]
  );

  return (
    <Flex columnGap="30px">
      <OrderHeaderCard
        title="Ordered"
        icon={<Icon as={EmrRegistration} />}
        bg={filter === "Ordered" || filter === null ? "orange" : "white"}
        color={filter === "Ordered" || filter === null ? "white" : "gray"}
        cursor="pointer"
        onClick={() => handleSetFilter("Ordered")}
        counter={getCounter("Ordered")}
        flex={1}
      />
      <OrderHeaderCard
        title="In Process"
        icon={<Icon as={EmrInProcess} />}
        bg={filter === "InProcess" || filter === null ? "blue" : "white"}
        color={filter === "InProcess" || filter === null ? "white" : "gray"}
        cursor="pointer"
        onClick={() => handleSetFilter("InProcess")}
        counter={getCounter("InProcess")}
        flex={1}
      />
      <OrderHeaderCard
        title="Completed"
        icon={<Icon as={SquaredChecked} />}
        bg={filter === "Completed" || filter === null ? "green" : "white"}
        color={filter === "Completed" || filter === null ? "white" : "gray"}
        cursor="pointer"
        onClick={() => handleSetFilter("Completed")}
        counter={getCounter("Completed")}
        flex={1}
      />
    </Flex>
  );
}

export { RadiologyCounters };
